module.exports = __webpack_public_path__ + "img/cod-badge-inactive.643d9b21.svg";